import { render, staticRenderFns } from "./SingleAwards.vue?vue&type=template&id=6b7aff4c&v-if=award%5B'situation'%5D%20%3D%3D%3D%20'open'"
import script from "./SingleAwards.vue?vue&type=script&lang=js"
export * from "./SingleAwards.vue?vue&type=script&lang=js"
import style0 from "./SingleAwards.vue?vue&type=style&index=0&id=6b7aff4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SingleAwards.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports